import { CCPOfferingContent, OfferingSKUMap } from "src/contentful";

import {
    PricingPeriod,
    PricingPlans,
    PricingTier,
    ProductKeyMap
} from "../constants";

import { convertCCPPricingPlansToHAMS } from "./ccp-to-hams-pricing-plan-converter";

export const extractPricingTiersFromEntry = (
    ccpOfferingsBySKU: OfferingSKUMap<CCPOfferingContent>,
    hamsPricingPlansByKey: ProductKeyMap<PricingPlans>,
    period: PricingPeriod,
    currencyISOCode: string,
    ccpOfferingSKU?: string,
    hamsProductKey?: string
): PricingTier[] | undefined => {
    let pricingPlans;

    let pricingTiers: PricingTier[];

    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];

        pricingPlans = offering?.defaultPricingPlans;
        if (!pricingPlans) {
            throw new Error(
                `Offering empty of pricing plan data for: ${ccpOfferingSKU}`
            );
        }

        const convertedTiers = convertCCPPricingPlansToHAMS(
            pricingPlans,
            currencyISOCode
        );
        if (period === "MONTHLY" && convertedTiers.monthly) {
            pricingTiers = convertedTiers.monthly.slice();
        } else if (period === "ANNUAL" && convertedTiers.annual) {
            pricingTiers = convertedTiers.annual.slice();
        } else {
            throw new Error(
                `Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`
            );
        }
    } else {
        if (hamsProductKey === undefined) {
            throw new Error(
                `HAMS product key was undefined for price request!`
            );
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            throw new Error(
                `No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`
            );
        }

        if (period === "MONTHLY" && pricingPlans.monthly) {
            pricingTiers = pricingPlans.monthly.slice();
        } else if (period === "ANNUAL" && pricingPlans.annual) {
            pricingTiers = pricingPlans.annual.slice();
        } else {
            throw new Error(
                `Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`
            );
        }
    }

    return pricingTiers;
};
